import { render, staticRenderFns } from "./MetadataModal.vue?vue&type=template&id=58c663f4&scoped=true"
import script from "./MetadataModal.vue?vue&type=script&lang=js"
export * from "./MetadataModal.vue?vue&type=script&lang=js"
import style0 from "./MetadataModal.vue?vue&type=style&index=0&id=58c663f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c663f4",
  null
  
)

export default component.exports